<template>
  <iconpark-icon v-bind="$attrs"></iconpark-icon>
</template>
<script lang="ts" setup></script>
